
export default {
    message: {
        hello: 'hello world',
        greeting: 'good morning, world!'
    }
}